import type { ICatalogBFFDetailedGood } from "../types/goods";
import type { IPromoProduct } from "@magnit/unit-catalog/src/types/VCatalogListing.types";
import useProduct from "../composables/useProduct";

const collectCardDetailCommonProps = (
  product: ICatalogBFFDetailedGood | IPromoProduct | null,
  categoryTitle: string,
  categoryId?: string,
) => {
  if (!product) return {};
  const { productId, productName, productDiscountCategory, productPrice } =
    useProduct(product);
  return {
    categoryTitle,
    categoryId,
    productName: productName.value,
    productId: productId.value,
    productPrice: productPrice.value,
    discountCategory: productDiscountCategory.value,
  };
};

export const collectCardDetailImagesPayload = (
  position: number,
  product: ICatalogBFFDetailedGood | IPromoProduct,
  categoryName: string,
) => {
  return {
    ...collectCardDetailCommonProps(product, categoryName),
    position,
  };
};

export const collectCardDetailTabPayload = (
  description: string,
  product: ICatalogBFFDetailedGood | IPromoProduct,
  categoryName: string,
) => {
  return {
    ...collectCardDetailCommonProps(product, categoryName),
    description,
  };
};

export const collectReviewPayload = (
  product: ICatalogBFFDetailedGood | IPromoProduct,
  categoryTitle: string,
  categoryId: string,
) => {
  return collectCardDetailCommonProps(product, categoryTitle, categoryId);
};

enum IPromoProductProgressiveDiscountType {
  CASHBACK = "cashback",
  PERCENT = "percent",
  PRICE = "price",
  MAGNETS = "magnets",
  BONUSES = "bonuses",
}

interface IPromoProductProgressiveDiscountValue {
  count: number;
  label?: string;
  countLabel: string;
  value: number;
}

export const collectCardDetailProgressiveDiscountPayload = (
  product: ICatalogBFFDetailedGood | IPromoProduct,
  variant: IPromoProductProgressiveDiscountValue,
  type: IPromoProductProgressiveDiscountType | undefined,
  categoryName: string,
) => {
  return {
    ...collectCardDetailCommonProps(product, categoryName),
    progressiveDiscount: variant,
    progressiveDiscountType: type || "",
  };
};

export const collectCardDetailShareSocialsPayload = (
  socialType: string,
  product: ICatalogBFFDetailedGood | IPromoProduct,
  categoryName: string,
) => {
  return {
    ...collectCardDetailCommonProps(product, categoryName),
    social_type: socialType,
  };
};
